// extracted by mini-css-extract-plugin
export default {"section":"VisionAndMission_section__GAgZ4","title":"VisionAndMission_title__Pgy7C","card":"VisionAndMission_card__ooT+T","desc":"VisionAndMission_desc__B92s2"};